import { track } from '@amplitude/analytics-browser'
import AmplitudeEvent from './AmplitudeEvent'

const log = (event: AmplitudeEvent): void => {
  track(event.name, event.properties)
}

export default log
